import SchedulingAddMobile from './SchedulingAddMobile';

export default SchedulingAddMobile;